import React from "react"
import TrueTag from "../../../../components/elements/TrueTag"
import { buildFilterTags } from "../../../../components/filters/ResourceSearchFilter/filterConfig"
import { removeFilter } from "../../useSearch/actionCreators"
import styles from "./index.module.scss"

const TagWrapper = ({ classes, searchParamGroup, dispatch }) => (
  <div className={classes}>
    {buildFilterTags(searchParamGroup).map((tag) => (
      <TrueTag
        key={tag.key}
        classes={styles.tag}
        title={tag.title}
        onClick={() => dispatch(removeFilter(tag.param, tag.value))}
      />
    ))}
  </div>
)
export default TagWrapper
